// src/components/PrivateRoute.js
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import { getRouteMenuPermission } from '../config/subscriptionConfig';

const PrivateRoute = ({ children, roles, allowCoordinator = false, allowInspector = false }) => {
  const { user, loading } = useContext(UserContext);
  const location = useLocation();

  if (loading) {
    return <div>Ładowanie...</div>;
  }

  if (!user || !user.accessToken) {
    console.warn("❌ Użytkownik niezalogowany - przekierowanie do /login");
    return <Navigate to="/login" replace />;
  }

  // Sprawdź czy użytkownik ma odpowiednią rolę LUB jest coordinatorem/inspektorem
  const hasRoleAccess = roles && roles.includes(user.role);
  const hasCoordinatorAccess = allowCoordinator && user.isCoordinator;
  const hasInspectorAccess = allowInspector && user.inspector;
  const hasAnyAccess = hasRoleAccess || hasCoordinatorAccess || hasInspectorAccess;
  const hasMenuPermissions = user.menuPermissions?.length > 0;

  // Trasy osobiste (roles zawiera user/userves) nie podlegają menu_permissions —
  // odpowiednik "user items" (przed separator-admin) w sidebarze.
  const isUserRoute = roles && (roles.includes('user') || roles.includes('userves'));
  // Klucz uprawnienia kategorii dla tej trasy (zgodny z hasAccessToMenuItem w sidebarze).
  const permissionKey = isUserRoute ? null : getRouteMenuPermission(location.pathname);
  // Dostęp przez rolę firmową: gdy mamy klucz trasy — wymagamy go na whitelist;
  // gdy trasa nie jest zmapowana — zgrubny fallback (jak dotychczas).
  const hasCompanyRoleAccess = hasMenuPermissions && (
    permissionKey ? user.menuPermissions.includes(permissionKey) : true
  );

  if (roles) {
    // Te same zasady co admin: użytkownik z przypisaną rolą firmową, który dociera
    // do trasy administracyjnej KTÓRĄKOLWIEK ścieżką (rola/coordinator/inspector),
    // jest ograniczony do kategorii wskazanych w jego menu_permissions.
    if (hasMenuPermissions && permissionKey && hasAnyAccess) {
      if (!user.menuPermissions.includes(permissionKey)) {
        console.warn(`⛔ [PrivateRoute] Kategoria '${permissionKey}' spoza roli firmowej - przekierowanie do /`);
        return <Navigate to="/" replace />;
      }
    } else if (!hasAnyAccess && !hasCompanyRoleAccess) {
      console.warn("⛔ Brak uprawnień - przekierowanie do /");
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default PrivateRoute;
